import React from "react";
import { Link } from "react-router-dom";
import { UserCompanies } from "../../components/companies";
import { DatamatesHeader } from "./header";
import DatamatesColumns from "./datamatesPoints";
import "./datamates.css";

const CTASection = () => (
  <div className="bg-gradient-to-r from-[#082247] to-[#1a3a5c] py-20 px-4">
    <div className="max-w-4xl mx-auto text-center">
      <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
        Ready for DataMates?
      </h2>
      <p className="text-xl text-white/80 mb-10">
        Add DataMates to your AI coding environment and experience what it's like to have teammates that understand your data world.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="https://datamates-docs.myaltimate.com/">
          <button className="px-8 py-4 bg-white hover:bg-gray-100 transition-all text-[#082247] text-lg font-medium rounded-xl hover:scale-[1.02]">
            Documentation
          </button>
        </Link>
        <Link to= "https://datamates-docs.myaltimate.com/#demo">
          <button className="px-8 py-4 bg-transparent hover:bg-white/10 transition-all text-white text-lg font-medium rounded-xl border-2 border-white hover:scale-[1.02]">
            See how it works
          </button>
        </Link>
      </div>
      <p className="text-white/60 mt-8 text-sm">
        Enterprise-ready with PII protection and custom integrations.{" "}
        <Link to="/pricing" className="text-white underline hover:no-underline">
          See our plans
        </Link>
      </p>
    </div>
  </div>
);

const TrustedBySection = () => (
  <div className="bg-white">
    <UserCompanies />
  </div>
);

const Datamates = () => (
  <div className="min-h-screen">
    <DatamatesHeader />
    <TrustedBySection />
    <DatamatesColumns />
    <CTASection />
  </div>
);

export default Datamates; 